import React from 'react'

// CSS
import "./index.css"

// Assets
import hero from "../../assets/images/hero.jpg"
import { Button, Container } from 'react-bootstrap'
import { Link } from 'react-router'


export default function Hero() {
  return (
    <Container
    fluid
    style={{ backgroundImage: `url(${hero})` }}
    className="heroBanner"
  >
    <div className="p-2 mb-5 innerHeroBanner">
      <h1>Investing Made Simple — Start Your Journey With Confidence</h1>
      <h6 className="pt-2">
        I break down stocks, ETFs, and long-term investing in a way anyone can understand.
        No fancy jargon. No gatekeeping. Just real portfolios and real learning as we grow together.
      </h6>
      <Link to="/portfolios">
      <Button className='mt-3'>Explore Beginner Portfolios</Button>
      </Link>
    </div>
  </Container>
  )
}
